<nav
  class="navbar navbar-expand-lg navbar-light"
  style="display: flex; justify-content: space-between;"
>
  <a class="navbar-brand" [routerLink]="['../home']"
    ><img src="../../../../assets/images/App-Logo.svg" alt="logo"
  /></a>

  <button
    id="ChangeToggle"
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarText"
    aria-controls="navbarText"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span id="navbar-hamburger" class="navbar-toggler-icon"></span>

    <span
      id="navbar-close"
      class="hidden"
      class="glyphicon glyphicon-remove"
    ></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarText">
    <span class="navbar-text">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <a
            class="nav-link"
            [routerLink]="['../services']"
            [routerLinkActive]="['services']"
            >Our APIs
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="https://docs.globalaccelerex.com/"
            target="_blank"
            >Documentation
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            [routerLink]="['../sign-in']"
            [routerLinkActive]="['active']"
            >Login</a
          >
        </li>
        <li class="nav-item">
          <button
            class="btn-lg get_started"
            [routerLink]="['../create-account']"
          >
            Sign Up
          </button>
        </li>
      </ul>
    </span>
  </div>
</nav>
